import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';

import { get } from './api';

export const getTicketRequestCategories: (
  roofTopId?: string
) => Promise<TicketRequestCategoryI[]> = async (
  roofTopId?: string
): Promise<TicketRequestCategoryI[]> => {
  const response = await get<TicketRequestCategoryI[]>(
    `/ticket-request-categories`,
    roofTopId ? { roofTopId } : undefined
  );

  return response.data;
};
